<template>
  <div class="unauthorized-page">
    <h1>403 - Unauthorized</h1>
    <p>You do not have permission to access this page.</p>
    <router-link to="/">Go back to Home</router-link>
  </div>
</template>

<script>
export default {
  name: 'Unauthorized',
};
</script>

<style scoped>
.unauthorized-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80vh;
  text-align: center;
  font-family: Arial, sans-serif;
}

h1 {
  color: #e74c3c;
  margin-bottom: 1rem;
}

p {
  margin-bottom: 1.5rem;
}

a {
  color: #3498db;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
</style>
